import { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SaveIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M16.56 6.06l-2.62-2.62c-.282-.282-.663-.44-1.061-.44H4.5C3.672 3 3 3.672 3 4.5v11c0 .828.672 1.5 1.5 1.5h11c.828 0 1.5-.672 1.5-1.5V7.121c0-.398-.158-.779-.44-1.06zM12 4v3H6V4h6zm4 11.5c0 .276-.224.5-.5.5h-11c-.276 0-.5-.224-.5-.5v-11c0-.276.224-.5.5-.5H5v3.25c0 .414.336.75.75.75h6.5c.414 0 .75-.336.75-.75V4.015c.088.022.168.067.232.131l2.622 2.622c.094.093.146.22.146.353V15.5zm-6-6.25c-1.516 0-2.75 1.234-2.75 2.75s1.234 2.75 2.75 2.75 2.75-1.234 2.75-2.75S11.516 9.25 10 9.25zm0 4.5c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.785 1.75 1.75-.785 1.75-1.75 1.75z" />
        </SvgIcon>
    );
};
